import * as actionTypes from "./paymentTypes";

const INITIAL_STATE = {
    toPayList: [],
    paymentReportList: [],
};

const paymentReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SET_TO_PAY_LIST:
            return {
                ...state,
                toPayList: action.payload.list,
            };
        case actionTypes.SET_PAYMENT_REPORT_LIST:
            return {
                ...state,
                paymentReportList: action.payload.list,
            };
        default:
            return state;
    };
};

export default paymentReducer;